import React from "react";
import CabIcon from "./CabIcon";

/**
 * Карточка игры в кабинете (GameCardView из Android, 1-в-1).
 * Квадратное превью + бейдж ОНЛАЙН/ХИТ, под ним название, автор, лайки.
 *
 * game: {id, title, author_username, thumbnail, likes_count,
 *        multiplayer, rating_percent}
 */
/** Компактный формат больших чисел: 1234 → 1.2K, 1500000 → 1.5M. */
function fmtCount(n) {
  const v = Number(n) || 0;
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (v >= 1_000) return (v / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return String(v);
}

export default function GameCardMini({ game, onClick }) {
  const {
    title,
    author_username: author,
    thumbnail,
    likes_count: likes = 0,
    play_count: plays = 0,
    multiplayer,
    rating_percent: ratingPercent = 0,
  } = game;

  // Валидный thumbnail: непустая строка (не "", не null, не undefined).
  // У некоторых игр (например, id=869 "Имена над врагами") thumbnail = "" —
  // без явной проверки React рендерит <img src="">, который ломает layout.
  const hasThumb = typeof thumbnail === "string" && thumbnail.length > 0;

  return (
    <button
      type="button"
      className="rb-gc"
      onClick={() => onClick && onClick(game.id)}
    >
      {/* aspect-ratio + явная высота: дублируем inline на случай если
          глобальный CSS img-reset перебивает .rb-gc__thumb img. */}
      <div
        className="rb-gc__thumb"
        style={{ aspectRatio: "1 / 1", overflow: "hidden", position: "relative" }}
      >
        {hasThumb ? (
          <img
            src={thumbnail}
            alt={title}
            loading="lazy"
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
        ) : (
          <div className="rb-gc__thumb-empty">{(title || "?").charAt(0)}</div>
        )}
        {multiplayer ? (
          <span className="rb-gc__badge rb-gc__badge--online">ОНЛАЙН</span>
        ) : ratingPercent >= 90 ? (
          <span className="rb-gc__badge rb-gc__badge--hit">ХИТ</span>
        ) : null}
        {/* Соц-доказательство: число запусков игры (как «playing» в Roblox,
            но честно — это всего запусков, live-онлайна у нас нет). Поверх
            обложки снизу, на градиентной подложке. */}
        {plays > 0 && (
          <span className="rb-gc__plays">
            <CabIcon name="play" size={10} />
            {fmtCount(plays)}
          </span>
        )}
      </div>
      <div className="rb-gc__body">
        <div className="rb-gc__title">{title}</div>
        <div className="rb-gc__meta">
          <span className="rb-gc__author">
            <CabIcon name="user" size={11} />
            {author}
          </span>
          <span className="rb-gc__likes">
            <CabIcon name="heart" size={11} />
            {likes}
          </span>
        </div>
      </div>
    </button>
  );
}
